import { getLokiBootstrapperConfig } from './../getLokiBootstrapperConfig';
import { fetchLokiConfigAsync as fetchLokiConfig } from '@msfast/lpc-bootstrapper';
import { LokiConfig } from './../models/models';

let lokiConfig = undefined;
let pendingRequest: Promise<LokiConfig> = null;

export function fetchLokiConfigAsync(): Promise<LokiConfig> {
    if (lokiConfig) {
        return Promise.resolve(lokiConfig);
    }

    if (!pendingRequest) {
        const bootstrapperConfig = getLokiBootstrapperConfig();

        pendingRequest = fetchLokiConfig(bootstrapperConfig).then(config => {
            pendingRequest = null;
            lokiConfig = config;
            return lokiConfig;
        });
    }

    return pendingRequest;
}

// Should only be called after fetchLokiConfigAsync has run
export function fetchLokiConfigSync(): LokiConfig {
    if (lokiConfig) {
        return lokiConfig;
    } else {
        try {
            fetchLokiConfigAsync();
        } catch {}
        return null;
    }
}
